

// import React, { useState, useEffect, useRef } from 'react';
// import { Box, Typography, InputBase, IconButton, CircularProgress } from '@mui/material';
// import { useSelector, useDispatch } from 'react-redux';
// import propertyImage from '../assets/inmenu.png';
// import userAvatar from '../assets/inboxuser.png';
// import agentAvatar from '../assets/inboxavatar.png';
// import attachIcon from '../assets/clipprof.png';
// import photoIcon from '../assets/clippho.png';
// import locationIcon from '../assets/cliploc.png';
// import sendIcon from '../assets/rocket.png';
// import tickIcon from '../assets/doubletick.png';
// import inboxheader from '../assets/inhead.png';
// import { setCurrentConversationId, setSenderId, setReceiverId, setConversations } from '../Commonlibs/userSlice';
// // Import Loader component
// import Loader from '../Loader/Loader';
// // Original chat list (will be replaced with API data)
// const chatList = [
//   { id: 1, title: 'Luxury Apartment', time: '2m ago', message: "I'm interested in your property...", unread: false },
//   { id: 2, title: 'Luxury Apartment', time: '2m ago', message: "I'm interested in your property...", unread: true },
//   { id: 3, title: 'Luxury Apartment', time: '2m ago', message: "I'm interested in your property...", unread: true },
//   { id: 4, title: 'Luxury Apartment', time: '2m ago', message: "I'm interested in your property...", unread: false },
//   { id: 5, title: 'Luxury Apartment', time: '2m ago', message: "I'm interested in your property...", unread: false },
// ];

// const defaultMessages = [
//   {
//     id: 1,
//     side: 'left',
//     sender: 'Sarah',
//     time: '10:30 AM',
//     text: "Hi, I'm interested in scheduling a viewing for the Modern Villa in Beverly Hills. Is it available this weekend?",
//     avatar: userAvatar,
//     status: 'read', // Add status to default messages
//   },
//   {
//     id: 2,
//     side: 'right',
//     sender: 'Alex',
//     time: '10:35 AM',
//     text: "Hello Sarah! Yes, we can arrange a viewing this Saturday at 2 PM. Would that work for you?",
//     avatar: agentAvatar,
//     status: 'read', // Add status to default messages
//   },
// ];
// // Import SVG icons for different message statuses
// const singleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//   <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;
// const doubleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//   <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M0.5 8L4.5 12L11.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;
// const doubleTickBlueSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//   <path d="M2.5 8L6.5 12L13.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
//   <path d="M0.5 8L4.5 12L11.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;
// const ProfileInbox = () => {
//   const [conversations, setLocalConversations] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [imageMap, setImageMap] = useState({});
//   const [messages, setMessages] = useState([]);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [messageError, setMessageError] = useState(null);
//   const [inputMessage, setInputMessage] = useState('');
//   const [currentConversationId, setLocalCurrentConversationId] = useState(null);
//   const [receiverId, setLocalReceiverId] = useState(null);
//   const [sendingMessage, setSendingMessage] = useState(false);
//   const [otherUserOnlineStatus, setOtherUserOnlineStatus] = useState(false);
//   const [otherUserLoggedInStatus, setOtherUserLoggedInStatus] = useState(false);
  
  
//   // Ref to store the polling interval ID
//   const onlineStatusIntervalRef = useRef(null);
  
//   // Get user data from Redux store
//   const user = useSelector((state) => state.user.user);
//   const dispatch = useDispatch();
  
//   // Ensure we have a valid user ID
//   const userId = user?.id;
  
//   // Function to check the online status of the other user in the conversation
//   const checkOtherUserOnlineStatus = async (otherUserId) => {
//     if (!otherUserId) {
//       console.log('No other user ID available, skipping online status check');
//       return;
//     }
    
//     try {
//       console.log(`Checking online status for other user ID: ${otherUserId}`);
      
//       // We'll use the updateOnlineStatus API since there's no dedicated getUserOnlineStatus API
//       // This is a workaround to get the online status
//       const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
//       console.log('Other User Online Status API URL:', apiUrl);
      
//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: otherUserId,
//           is_online: true // This is just for the query, not actually updating
//         })
//       });
      
//       if (!response.ok) {
//         console.error('Other user online status API response not OK:', response.status, response.statusText);
//         throw new Error(`Other user online status API request failed with status ${response.status}`);
//       }
      
//       const data = await response.json();
//       console.log('Other user online status API response:', data);
      
//       if (data.statusCode === 200) {
//         const isOnline = data.result?.is_online || false;
//         const isLoggedIn = data.result?.is_logged_in || false; // Check if user is logged in
        
//         console.log(`Other user (${otherUserId}) online status:`, isOnline);
//         console.log(`Other user (${otherUserId}) logged in status:`, isLoggedIn);
        
//         // Update the online status in the UI
//         const prevOnlineStatus = otherUserOnlineStatus;
//         const prevLoggedInStatus = otherUserLoggedInStatus;
        
//         setOtherUserOnlineStatus(isOnline);
//         setOtherUserLoggedInStatus(isLoggedIn);
        
//         // Also update the selected conversation object to reflect the new online status
//         setSelectedConversation(prevConversation => {
//           if (!prevConversation) return prevConversation;
//           return {
//             ...prevConversation,
//             is_other_user_online: isOnline,
//             is_other_user_logged_in: isLoggedIn
//           };
//         });
//         // Update message statuses based on receiver's status changes
//         setMessages(prevMessages => 
//           prevMessages.map(msg => {
//             // Only update statuses for messages sent by the current user
//             if (msg.sender_id === userId) {
//               // If receiver was offline and now is online or logged in
//               if (!prevLoggedInStatus && isLoggedIn && msg.status === 'sent') {
//                 return { ...msg, status: 'delivered' };
//               }
//               // If message is read, don't change it
//               else if (msg.status === 'read') {
//                 return msg;
//               }
//               // If receiver is online and viewing the message, mark as read
//               else if (isOnline && msg.status === 'delivered') {
//                 return { ...msg, status: 'read' };
//               }
//               // If receiver has logged out, revert to sent status (single tick)
//               else if (prevLoggedInStatus && !isLoggedIn) {
//                 return { ...msg, status: 'sent' };
//               }
//             }
//             return msg;
//           })
//         );
//       } else {
//         console.error('Other user online status API returned non-200 status code:', data.statusCode);
//       }
//     } catch (err) {
//       console.error('Error checking other user online status:', err);
//       // Don't update the state in case of error to avoid flickering
//     }
//   };
  
//   // Update online status when component mounts and when user changes
//   useEffect(() => {
//     if (!userId) {
//       console.log('No user ID available, skipping online status update');
//       return;
//     }
    
//     const updateOnlineStatus = async () => {
//       try {
//         console.log(`Updating online status for user ID: ${userId}`);
        
//         const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
//         console.log('Online Status API URL:', apiUrl);
        
//         const response = await fetch(apiUrl, {
//           method: 'POST',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             user_id: userId,
//             is_online: true
//           })
//         });
        
//         if (!response.ok) {
//           console.error('Online status update API response not OK:', response.status, response.statusText);
//           throw new Error(`Online status update API request failed with status ${response.status}`);
//         }
        
//         const data = await response.json();
//         console.log('Online status update API response:', data);
        
//         if (data.statusCode !== 200) {
//           console.error('Online status update API returned non-200 status code:', data.statusCode);
//           throw new Error(data.message || 'Failed to update online status');
//         }
//       } catch (err) {
//         console.error('Error updating online status:', err);
//       }
//     };
    
//     // Update online status when component mounts
//     updateOnlineStatus();
    
//     // Set up interval to update online status periodically (e.g., every 1 minute)
//     const intervalId = setInterval(updateOnlineStatus, 1 * 60 * 1000);
    
//     // Set up event listener for when user leaves the page
//     const handleBeforeUnload = () => {
//       // Try to update online status to false when user leaves
//       fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           is_online: false
//         }),
//         // Use keepalive to ensure the request completes even if the page is unloading
//         keepalive: true
//       }).catch(err => console.error('Error updating offline status:', err));
//     };
    
//     window.addEventListener('beforeunload', handleBeforeUnload);
    
//     // Clean up interval and event listener on component unmount
//     return () => {
//       clearInterval(intervalId);
//       window.removeEventListener('beforeunload', handleBeforeUnload);
      
//       // Set user as offline when component unmounts
//       fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           is_online: false
//         }),
//         // Use keepalive to ensure the request completes even if the page is unloading
//         keepalive: true
//       }).catch(err => console.error('Error updating offline status on unmount:', err));
//     };
//   }, [userId]);
//   // Set up polling for other user's online status when receiverId changes
//   useEffect(() => {
//     // Clear any existing interval
//     if (onlineStatusIntervalRef.current) {
//       clearInterval(onlineStatusIntervalRef.current);
//       onlineStatusIntervalRef.current = null;
//     }
    
//     if (!receiverId) {
//       return;
//     }
    
//     // Check immediately
//     checkOtherUserOnlineStatus(receiverId);
    
//     // Then set up interval to check every 5 seconds
//     onlineStatusIntervalRef.current = setInterval(() => {
//       checkOtherUserOnlineStatus(receiverId);
//     }, 5 * 1000); // 5 seconds
    
//     return () => {
//       if (onlineStatusIntervalRef.current) {
//         clearInterval(onlineStatusIntervalRef.current);
//         onlineStatusIntervalRef.current = null;
//       }
//     };
//   }, [receiverId]);
//   // Function to mark messages as read
//   const markMessagesAsRead = async (conversationId) => {
//     if (!userId || !conversationId) {
//       console.log('Missing user ID or conversation ID, skipping mark as read');
//       return;
//     }
    
//     try {
//       console.log(`Marking messages as read for conversation ID: ${conversationId}, user ID: ${userId}`);
      
//       const apiUrl = `https://propertydealstalk.com/api/messaging/markMessagesAsRead`;
//       console.log('Mark as Read API URL:', apiUrl);
      
//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           conversation_id: conversationId,
//           user_id: userId
//         })
//       });
      
//       if (!response.ok) {
//         console.error('Mark as read API response not OK:', response.status, response.statusText);
//         throw new Error(`Mark as read API request failed with status ${response.status}`);
//       }
      
//       const data = await response.json();
//       console.log('Mark as read API response:', data);
      
//       if (data.statusCode !== 200) {
//         console.error('Mark as read API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to mark messages as read');
//       }
      
//       console.log(`Successfully marked ${data.result.messages_updated} messages as read`);
      
//       // Update the local conversations to reflect the read status
//       setLocalConversations(prevConversations => 
//         prevConversations.map(conv => 
//           conv.conversation_id === conversationId
//             ? {
//                 ...conv,
//                 last_message: {
//                   ...conv.last_message,
//                   status: 'read'
//                 }
//               }
//             : conv
//         )
//       );
      
//       // Update message status to 'read' for received messages
//       setMessages(prevMessages => 
//         prevMessages.map(msg => 
//           msg.sender_id !== userId && msg.status !== 'read'
//             ? { ...msg, status: 'read' }
//             : msg
//         )
//       );
      
//     } catch (err) {
//       console.error('Error marking messages as read:', err);
//     }
//   };
//   // Fetch conversations on component mount or when userId changes
//   useEffect(() => {
//     // Don't fetch if there's no user ID
//     if (!userId) {
//       console.log('No user ID available, skipping API call');
//       return;
//     }
//     const fetchConversations = async () => {
//       setLoading(true);
//       try {
//         console.log(`Fetching conversations for user ID: ${userId}`);
        
//         // Use a simplified API request to avoid sending large data in headers
//         const apiUrl = `https://propertydealstalk.com/api/messaging/conversations?user_id=${userId}`;
//         console.log('API URL:', apiUrl);
        
//         const response = await fetch(apiUrl, {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//             'Cache-Control': 'no-cache, no-store'
//           }
//         });
        
//         if (!response.ok) {
//           console.error('API response not OK:', response.status, response.statusText);
//           throw new Error(`API request failed with status ${response.status}`);
//         }
        
//         const data = await response.json();
//         console.log('API response:', data);
        
//         if (data.statusCode === 200) {
//           console.log('Conversations data:', data.result);
          
//           // Create a new image map for processed images
//           const newImageMap = {};
          
//           // Process the conversations
//           const processedConversations = data.result.map(conversation => {
//             let conversationWithDefaultImage = {
//               ...conversation,
//               property: {
//                 ...conversation.property,
//                 // Use fallback image initially
//                 image: propertyImage
//               }
//             };
            
//             // Process the image if it exists
//             if (conversation.property && conversation.property.image) {
//               try {
//                 // Check if the image is in the format we expect (starts with /9j/)
//                 if (typeof conversation.property.image === 'string' && conversation.property.image.startsWith('/9j/')) {
//                   // Create a complete data URL with the proper prefix
//                   const dataUrl = `data:image/jpeg;base64,${conversation.property.image}`;
                  
//                   // Store in our image map
//                   newImageMap[conversation.conversation_id] = dataUrl;
                  
//                   // Update the conversation with the processed image
//                   conversationWithDefaultImage.property.image = dataUrl;
//                 }
//               } catch (err) {
//                 console.error('Error processing image:', err);
//                 // Keep the fallback image if there's an error
//               }
//             }
            
//             return conversationWithDefaultImage;
//           });
          
//           // Update the image map
//           setImageMap(newImageMap);
          
//           // Update conversations state locally
//           setLocalConversations(processedConversations);
          
//           // Only update Redux if we have processedConversations
//           if (processedConversations && processedConversations.length > 0) {
//             try {
//               dispatch(setConversations(processedConversations));
//             } catch (err) {
//               console.error('Error updating Redux state:', err);
//             }
//           }
          
//           // Select the first conversation by default if available and no conversation is selected
//           if (processedConversations.length > 0 && !currentConversationId) {
//             // FIX: Use array indexing to get the first conversation
//             const firstConversation = processedConversations; // Fixed: Use proper array indexing
//             setSelectedConversation(firstConversation);
//             setLocalCurrentConversationId(firstConversation.conversation_id);
            
//             // Set the receiver ID based on the other_user in the conversation
//             if (firstConversation.other_user && firstConversation.other_user.id) {
//               const otherUserId = firstConversation.other_user.id;
//               setLocalReceiverId(otherUserId);
              
//               // Check online status of the other user
//               checkOtherUserOnlineStatus(otherUserId);
              
//               try {
//                 dispatch(setReceiverId(otherUserId));
//               } catch (err) {
//                 console.error('Error updating Redux receiver ID:', err);
//               }
//             }
            
//             try {
//               dispatch(setCurrentConversationId(firstConversation.conversation_id));
//               if (firstConversation.other_user && firstConversation.other_user.id) {
//                 dispatch(setSenderId(firstConversation.other_user.id));
//               }
//             } catch (err) {
//               console.error('Error updating Redux state:', err);
//             }
            
//             // Fetch messages for the first conversation using its conversation_id
//             fetchMessages(firstConversation.conversation_id);
            
//             // Mark messages as read for the first conversation
//             markMessagesAsRead(firstConversation.conversation_id);
//           } else if (currentConversationId) {
//             // If we already have a selected conversation, use that
//             const existingConversation = processedConversations.find(
//               conv => conv.conversation_id === currentConversationId
//             );
            
//             if (existingConversation) {
//               setSelectedConversation(existingConversation);
              
//               // Set the receiver ID based on the other_user in the conversation
//               if (existingConversation.other_user && existingConversation.other_user.id) {
//                 const otherUserId = existingConversation.other_user.id;
//                 setLocalReceiverId(otherUserId);
                
//                 // Check online status of the other user
//                 checkOtherUserOnlineStatus(otherUserId);
                
//                 try {
//                   dispatch(setReceiverId(otherUserId));
//                 } catch (err) {
//                   console.error('Error updating Redux receiver ID:', err);
//                 }
//               }
              
//               fetchMessages(currentConversationId);
              
//               // Mark messages as read for the current conversation
//               markMessagesAsRead(currentConversationId);
//             }
//           }
//         } else {
//           console.error('API returned non-200 status code:', data.statusCode);
//           throw new Error(data.message || 'Failed to fetch conversations');
//         }
//       } catch (err) {
//         console.error('Error fetching conversations:', err);
//         console.error('Error details:', err.message);
//         console.error('Error stack:', err.stack);
//         setError(`Error: Failed to fetch. Please try again later.`);
//         // Use fallback data in case of error
//         setLocalConversations([]);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchConversations();
//   }, [userId, dispatch]); // Removed currentConversationId from dependencies to avoid re-fetching
//   // Function to fetch messages for a specific conversation
//   const fetchMessages = async (conversationId) => {
//     if (!userId || !conversationId) {
//       console.log('Missing user ID or conversation ID, skipping message fetch');
//       return;
//     }
//     setLoadingMessages(true);
//     setMessageError(null);
//     try {
//       console.log(`Fetching messages for conversation ID: ${conversationId}, user ID: ${userId}`);
      
//       const apiUrl = `https://propertydealstalk.com/api/messaging/getMessages?conversation_id=${conversationId}&user_id=${userId}`;
//       console.log('Messages API URL:', apiUrl);
      
//       const response = await fetch(apiUrl, {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           'Cache-Control': 'no-cache, no-store'
//         }
//       });
      
//       if (!response.ok) {
//         console.error('Messages API response not OK:', response.status, response.statusText);
//         throw new Error(`Messages API request failed with status ${response.status}`);
//       }
      
//       const data = await response.json();
//       console.log('Messages API response:', data);
      
//       if (data.statusCode === 200) {
//         console.log('Messages data:', data.result.messages);
//         const messagesArray = Array.isArray(data.result.messages) ? data.result.messages : [];
        
//         // Update messages with proper status based on online status
//         const processedMessages = messagesArray.map(msg => {
//           // For messages sent by current user, set status based on receiver's status
//           if (msg.sender_id === userId) {
//             // If status is not provided, set a default based on receiver's status
//             if (!msg.status) {
//               if (otherUserOnlineStatus) {
//                 return { ...msg, status: 'read' };
//               } else if (otherUserLoggedInStatus) {
//                 return { ...msg, status: 'delivered' };
//               } else {
//                 return { ...msg, status: 'sent' };
//               }
//             }
//           } else {
//             // For received messages, mark as read since user is viewing them
//             return { ...msg, status: 'read' };
//           }
//           return msg;
//         });
        
//         setMessages(processedMessages);
        
//         // If we don't have a receiver ID yet, try to get it from the selected conversation
//         if (!receiverId && selectedConversation?.other_user?.id) {
//           const otherUserId = selectedConversation.other_user.id;
//           setLocalReceiverId(otherUserId);
          
//           // Check online status of the other user
//           checkOtherUserOnlineStatus(otherUserId);
          
//           try {
//             dispatch(setReceiverId(otherUserId));
//           } catch (err) {
//             console.error('Error updating Redux receiver ID:', err);
//           }
//         }
        
//         // Mark messages as read after fetching them
//         markMessagesAsRead(conversationId);
//       } else {
//         console.error('Messages API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to fetch messages');
//       }
//     } catch (err) {
//       console.error('Error fetching messages:', err);
//       console.error('Error details:', err.message);
//       setMessageError('Failed to load messages. Please try again later.');
//       // Use fallback data in case of error
//       setMessages([]);
//     } finally {
//       setLoadingMessages(false);
//     }
//   };
  
//   // Function to send a message
//   const sendMessage = async (messageText) => {
//     // Check if we have all required data
//     if (!messageText.trim()) {
//       console.log('Message text is empty');
//       return;
//     }
    
//     if (!currentConversationId) {
//       console.log('Missing conversation ID');
//       return;
//     }
    
//     if (!userId) {
//       console.log('Missing user ID');
//       return;
//     }
    
//     // If receiverId is not set, try to get it from the selected conversation
//     let actualReceiverId = receiverId;
//     if (!actualReceiverId && selectedConversation?.other_user?.id) {
//       actualReceiverId = selectedConversation.other_user.id;
//       setLocalReceiverId(actualReceiverId);
      
//       // Check online status of the other user
//       checkOtherUserOnlineStatus(actualReceiverId);
      
//       try {
//         dispatch(setReceiverId(actualReceiverId));
//       } catch (err) {
//         console.error('Error updating Redux receiver ID:', err);
//       }
//     }
    
//     if (!actualReceiverId) {
//       console.log('Missing receiver ID and cannot determine from conversation');
//       return;
//     }
    
//     setSendingMessage(true);
//     try {
//       // Determine initial message status based on receiver's status
//       // Default is 'sent' (single tick) if receiver is not logged in
//       let initialStatus = 'sent';
      
//       if (otherUserOnlineStatus) {
//         // If receiver is online, mark as read (double blue tick)
//         initialStatus = 'read';
//       } else if (otherUserLoggedInStatus) {
//         // If receiver is logged in but not online, mark as delivered (double gray tick)
//         initialStatus = 'delivered';
//       }
      
//       // Create a temporary message to show immediately
//       const tempMessage = {
//         message_id: `temp-${Date.now()}`,
//         message_text: messageText,
//         sender_id: userId,
//         sender_name: user?.full_name || 'You',
//         receiver_id: actualReceiverId,
//         receiver_name: 'Receiver',
//         timestamp: new Date().toISOString(),
//         status: initialStatus
//       };
      
//       // Add the temp message to the UI
//       setMessages(prevMessages => [...prevMessages, tempMessage]);
      
//       // Clear the input field
//       setInputMessage('');
      
//       // Send the message to the API
//       const apiUrl = 'https://propertydealstalk.com/api/messaging/sendMessage';
//       console.log('Send Message API URL:', apiUrl);
      
//       const requestBody = {
//         conversation_id: currentConversationId,
//         receiver_id: actualReceiverId,
//         sender_id: userId,
//         message_text: messageText
//       };
      
//       console.log('Sending message with data:', requestBody);
      
//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(requestBody)
//       });
      
//       if (!response.ok) {
//         console.error('Send message API response not OK:', response.status, response.statusText);
//         throw new Error(`Send message API request failed with status ${response.status}`);
//       }
      
//       const data = await response.json();
//       console.log('Send message API response:', data);
      
//       if (data.statusCode === 200) {
//         console.log('Message sent successfully:', data.result);
        
//         // Update the temporary message with the actual message data
//         // Keep the status we determined based on online status
//         setMessages(prevMessages => 
//           prevMessages.map(msg => 
//             msg.message_id === tempMessage.message_id 
//               ? {
//                   ...msg,
//                   message_id: data.result.message_id,
//                   timestamp: data.result.timestamp,
//                   status: initialStatus // Keep our status based on online status
//                 }
//               : msg
//           )
//         );
//       } else {
//         console.error('Send message API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to send message');
//       }
//     } catch (err) {
//       console.error('Error sending message:', err);
//       console.error('Error details:', err.message);
      
//       // Update the temporary message to show an error state
//       setMessages(prevMessages => 
//         prevMessages.map(msg => 
//           msg.status === 'sending' 
//             ? { ...msg, status: 'failed' }
//             : msg
//         )
//       );
//     } finally {
//       setSendingMessage(false);
//     }
//   };
//     // Handle conversation selection
// const handleConversationSelect = (conversation) => {
//   setSelectedConversation(conversation);
//   setLocalCurrentConversationId(conversation.conversation_id);
  
//   // Set the receiver ID based on the other_user in the conversation
//   if (conversation.other_user && conversation.other_user.id) {
//     const otherUserId = conversation.other_user.id;
//     setLocalReceiverId(otherUserId);
    
//     // Check online status of the other user
//     checkOtherUserOnlineStatus(otherUserId);
    
//     try {
//       dispatch(setReceiverId(otherUserId));
//     } catch (err) {
//       console.error('Error updating Redux receiver ID:', err);
//     }
//   }
  
//   try {
//     dispatch(setCurrentConversationId(conversation.conversation_id));
//     if (conversation.other_user && conversation.other_user.id) {
//       dispatch(setSenderId(conversation.other_user.id));
//     }
//   } catch (err) {
//     console.error('Error updating Redux state:', err);
//   }
  
//   fetchMessages(conversation.conversation_id);
  
//   // Mark messages as read when selecting a conversation
//   markMessagesAsRead(conversation.conversation_id);
// };

// // Format timestamp to relative time (e.g., "2m ago")
// const formatRelativeTime = (timestamp) => {
//   if (!timestamp) return '';
//   try {
//     const now = new Date();
//     const messageTime = new Date(timestamp);
    
//     // Check if the date is valid
//     if (isNaN(messageTime.getTime())) {
//       console.error('Invalid date:', timestamp);
//       return 'Invalid date';
//     }
    
//     const diffInMs = now - messageTime;
//     const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    
//     if (diffInMinutes < 1) return 'just now';
//     if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
//     const diffInHours = Math.floor(diffInMinutes / 60);
//     if (diffInHours < 24) return `${diffInHours}h ago`;
    
//     const diffInDays = Math.floor(diffInHours / 24);
//     if (diffInDays < 7) return `${diffInDays}d ago`;
    
//     // Format as MM/DD/YYYY for older dates
//     return messageTime.toLocaleDateString();
//   } catch (error) {
//     console.error('Error formatting date:', error);
//     return 'Date error';
//   }
// };

// // Format time as HH:MM AM/PM
// const formatMessageTime = (timestamp) => {
//   if (!timestamp) return '';
//   try {
//     const date = new Date(timestamp);
    
//     // Check if the date is valid
//     if (isNaN(date.getTime())) {
//       return 'Invalid time';
//     }
    
//     return date.toLocaleTimeString('en-US', {
//       hour: 'numeric',
//       minute: '2-digit',
//       hour12: true
//     });
//   } catch (error) {
//     console.error('Error formatting time:', error);
//     return 'Time error';
//   }
// };
// // Function to get the appropriate tick icon based on message status
// const getMessageStatusIcon = (status, isSentByCurrentUser) => {
//   // Only show status icons for messages sent by the current user
//   if (!isSentByCurrentUser) return null;
  
//   switch (status) {
//     case 'sent':
//       // Single gray tick
//       return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
//     case 'delivered':
//       // Double gray tick
//       return <div dangerouslySetInnerHTML={{ __html: doubleTickSvg }} />;
//     case 'read':
//       // Double blue tick
//       return <div dangerouslySetInnerHTML={{ __html: doubleTickBlueSvg }} />;
//     case 'failed':
//       // Error icon or text
//       return <Typography sx={{ color: 'red', fontSize: '10px' }}>Failed</Typography>;
//     default:
//       // Default to single tick
//       return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
//   }
// };
// // If there's no user ID, show a message to log in
// if (!userId) {
//   return (
//     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column', gap: 2 }}>
//       <Typography variant="h6">Please log in to view your messages</Typography>
//       <Typography variant="body2" color="text.secondary">
//         You need to be logged in to access your conversations
//       </Typography>
//     </Box>
//   );
// }
// // Show the Loader component when loading
// if (loading) return <Loader />;
// return (
//   <Box
//     sx={{
//       flex: 1,
//       display: 'flex',
//       flexDirection: { xs: 'column', md: 'row' },
//       gap: { xs: '10px', md: '20px' },
//       width: '100%',
//     }}
//   >
//     {/* Inbox List */}
//     <Box
//       sx={{
//         width: { xs: '100%', md: '320px' },
//         background: '#fff',
//         borderRadius: '8px',
//         display: 'flex',
//         flexDirection: 'column',
//         overflowY: 'auto',
//         padding: { xs: '20px 12px 0', md: '46px 16px 0 16px' },
//       }}
//     >
//       {error ? (
//         <Box sx={{ padding: '20px', textAlign: 'center' }}>
//           <Typography sx={{ color: 'red', marginBottom: '10px' }}>
//             Error: Failed to fetch. Please try again later.
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Showing demo data instead
//           </Typography>
//           {/* Show demo data when there's an error */}
//           {chatList.map((chat) => (
//             <Box
//               key={chat.id}
//               sx={{
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 padding: '10px',
//                 border: '2px solid #f1f1f1',
//                 borderRadius: '9px',
//                 cursor: 'pointer',
//                 marginTop: '10px',
//               }}
//             >
//               <Box
//                 component="img"
//                 src={propertyImage}
//                 alt="Property"
//                 sx={{
//                   width: '40px',
//                   height: '38px',
//                   borderRadius: '8px',
//                   marginRight: '12px',
//                   objectFit: 'cover',
//                 }}
//               />
//               <Box sx={{ flex: 1 }}>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'flex-start',
//                   }}
//                 >
//                   <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600 }}>
//                     {chat.title}
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'flex-end',
//                     }}
//                   >
//                     {chat.unread && (
//                       <Box
//                         sx={{
//                           width: '8px',
//                           height: '8px',
//                           background: 'red',
//                           borderRadius: '50%',
//                         }}
//                       />
//                     )}
//                     <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
//                       {chat.time}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555' }}>
//                   {chat.message}
//                 </Typography>
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       ) : conversations.length > 0 ? (
//         conversations.map((conversation) => (
//           <Box
//             key={conversation.conversation_id}
//             sx={{
//               display: 'flex',
//               alignItems: 'flex-start',
//               padding: '10px',
//               border: '2px solid #f1f1f1',
//               borderRadius: '9px',
//               cursor: 'pointer',
//               marginBottom: '20px',
//               backgroundColor: selectedConversation?.conversation_id === conversation.conversation_id ? '#f8f9fa' : 'transparent',
//             }}
//             onClick={() => handleConversationSelect(conversation)}
//           >
//             {/* Use the img element directly instead of Box component for better debugging */}
//             <img
//               src={conversation.property.image}
//               alt="Property"
//               style={{
//                 width: '40px',
//                 height: '38px',
//                 borderRadius: '8px',
//                 marginRight: '12px',
//                 objectFit: 'cover',
//               }}
//               onError={(e) => {
//                 console.warn('Image failed to load, using fallback');
//                 e.target.src = propertyImage;
//               }}
//             />
//             <Box sx={{ flex: 1 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'flex-start',
//                 }}
//               >
//                 <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600 }}>
//                   {conversation.property.property_name}
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'flex-end',
//                   }}
//                 >
//                   {conversation.last_message.status !== 'read' && (
//                     <Box
//                       sx={{
//                         width: '8px',
//                         height: '8px',
//                         background: 'red',
//                         borderRadius: '50%',
//                       }}
//                     />
//                   )}
//                   <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
//                     {formatRelativeTime(conversation.last_message_time)}
//                   </Typography>
//                 </Box>
//               </Box>
//               <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555' }}>
//                 {conversation.last_message.message_text}
//               </Typography>
//             </Box>
//           </Box>
//         ))
//       ) : (
//         // If no conversations, show the original chat list
//         chatList.map((chat) => (
//           <Box
//             key={chat.id}
//             sx={{
//               display: 'flex',
//               alignItems: 'flex-start',
//               padding: '10px',
//               border: '2px solid #f1f1f1',
//               borderRadius: '9px',
//               cursor: 'pointer',
//               marginBottom: '20px',
//             }}
//           >
//             <Box
//               component="img"
//               src={propertyImage}
//               alt="Property"
//               sx={{
//                 width: '40px',
//                 height: '38px',
//                 borderRadius: '8px',
//                 marginRight: '12px',
//                 objectFit: 'cover',
//               }}
//             />
//             <Box sx={{ flex: 1 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'flex-start',
//                 }}
//               >
//                 <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600 }}>
//                   {chat.title}
//                 </Typography>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     alignItems: 'flex-end',
//                   }}
//                 >
//                   {chat.unread && (
//                     <Box
//                       sx={{
//                         width: '8px',
//                         height: '8px',
//                         background: 'red',
//                         borderRadius: '50%',
//                       }}
//                     />
//                   )}
//                   <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
//                     {chat.time}
//                   </Typography>
//                 </Box>
//               </Box>
//               <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555' }}>
//                 {chat.message}
//               </Typography>
//             </Box>
//           </Box>
//         ))
//       )}
//     </Box>
//     {/* Chatbox */}
//     <Box
//       sx={{
//         flex: 1,
//         display: 'flex',
//         flexDirection: 'column',
//         background: '#fff',
//         borderRadius: '8px',
//         maxWidth: { md: '660px', xs: '100%' },
//         width: '100%',
//       }}
//     >
//       {/* Header section - Modified to show "Select a conversation" when no conversation is selected */}
//   {/* Header section - Modified to ensure it only shows when a valid conversation is selected */}
// {selectedConversation && selectedConversation.property ? (
//   <Box
//     sx={{
//       display: 'flex',
//       flexDirection: { xs: 'column', md: 'row' },
//       alignItems: 'flex-start',
//       padding: { xs: '12px', md: '25px 9px 0 9px' },
//       borderBottom: '2px solid #eee',
//       height: { xs: 'auto', md: '110px' },
//     }}
//   >
//     {/* Use img element for better debugging */}
//     <img
//       src={selectedConversation.property.image || inboxheader}
//       alt="Property"
//       style={{
//         width: '140px',
//         height: '70px',
//         borderRadius: '8px',
//         marginRight: '22px',
//         marginLeft: '20px',
//         objectFit: 'cover',
//       }}
//       onError={(e) => {
//         console.warn('Header image failed to load, using fallback');
//         e.target.src = inboxheader;
//       }}
//     />
//     <Box>
//       <Typography sx={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>
//         {selectedConversation.property.property_name}
//       </Typography>
//       <Typography
//         sx={{
//           margin: '8px 0',
//           fontSize: '16px',
//           fontWeight: 600,
//           color: '#2563eb'
//         }}
//       >
//         {selectedConversation.property.currency}{selectedConversation.property.asking_price}
//       </Typography>
//       <Typography sx={{ margin: 0, fontSize: '12px', color: '#444' }}>
//         {selectedConversation.property.location}
//       </Typography>
//     </Box>
//     <Typography
//       sx={{
//         marginLeft: 'auto',
//         fontSize: '14px',
//         color: selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'green' : '#888',
//         alignSelf: 'flex-end',
//         marginBottom: '6px',
//       }}
//     >
//       ● {selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'Online' : 'Offline'}
//     </Typography>
//   </Box>
// ) : (
//   // Show only "Select a conversation" message when no conversation is selected
//   <Box 
//     sx={{ 
//       display: 'flex', 
//       justifyContent: 'center', 
//       alignItems: 'center', 
//       width: '100%',
//       height: '110px',
//       borderBottom: '2px solid #eee',
//     }}
//   >
//     <Typography sx={{ color: '#888', fontSize: '14px' }}>
//       Select a conversation
//     </Typography>
//   </Box>
// )}

//       {/* Messages */}
//       {selectedConversation ? (
//         <>
//           <Box
//             sx={{
//               flex: 1,
//               padding: '24px',
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '28px',
//               overflowY: 'auto',
//             }}
//           >
//             {loadingMessages ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
//                 <CircularProgress size={24} />
//               </Box>
//             ) : messageError ? (
//               <Box sx={{ padding: '20px', textAlign: 'center' }}>
//                 <Typography sx={{ color: 'red', marginBottom: '10px' }}>
//                   {messageError}
//                 </Typography>
//                 {/* Show default messages when there's an error */}
//                 {defaultMessages.map((msg) => (
//                   <Box
//                     key={msg.id}
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'flex-start',
//                       maxWidth: '100%',
//                       flexDirection: msg.side === 'left' ? 'row' : 'row-reverse',
//                       alignSelf: msg.side === 'right' ? 'flex-end' : 'flex-start',
//                       marginTop: '20px',
//                     }}
//                   >
//                     <Box
//                       component="img"
//                       src={msg.avatar}
//                       alt={msg.sender}
//                       sx={{
//                         width: { xs: '30px', md: '62px' },
//                         height: { xs: '30px', md: '52px' },
//                         borderRadius: '50%',
//                       }}
//                       onError={(e) => {
//                         console.warn('Avatar image failed to load');
//                         e.target.src = msg.side === 'left' ? userAvatar : agentAvatar;
//                       }}
//                     />
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         marginLeft: msg.side === 'left' ? '10px' : 0,
//                         marginRight: msg.side === 'right' ? '10px' : 0,
//                         alignItems: msg.side === 'right' ? 'flex-end' : 'flex-start',
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: { xs: '12px', md: '13px' },
//                           fontWeight: 600,
//                           marginBottom: '4px',
//                           color: '#2563eb',
//                           textAlign: msg.side === 'right' ? 'right' : 'left',
//                         }}
//                       >
//                         {msg.sender}
//                       </Typography>
//                       <Box
//                         sx={{
//                           background: msg.side === 'right' ? '#2563eb' : '#f1f5f9',
//                           color: msg.side === 'right' ? '#fff' : '#000',
//                           borderRadius: '10px',
//                           padding: { xs: '8px 12px', md: '12px 16px' },
//                           fontSize: { xs: '12px', md: '13px' },
//                         }}
//                       >
//                         {msg.text}
//                       </Box>
//                       <Box
//                         sx={{
//                           fontSize: { xs: '10px', md: '11px' },
//                           color: '#888',
//                           marginTop: '8px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '4px',
//                           justifyContent: msg.side === 'right' ? 'flex-end' : 'flex-start',
//                         }}
//                       >
//                         {msg.time}
//                         {/* Use our new status icon function for demo messages */}
//                         {getMessageStatusIcon(msg.status, msg.side === 'right')}
//                       </Box>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             ) : messages.length > 0 ? (
//               messages.map((message) => {
//                 // Determine if the message is from the current user
//                 const isSentByCurrentUser = message.sender_id === userId;
                
//                 return (
//                   <Box
//                     key={message.message_id}
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'flex-start',
//                       maxWidth: '100%',
//                       flexDirection: isSentByCurrentUser ? 'row-reverse' : 'row',
//                       alignSelf: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                     }}
//                   >
//                     <Box
//                       component="img"
//                       src={isSentByCurrentUser ? agentAvatar : userAvatar}
//                       alt={message.sender_name}
//                       sx={{
//                         width: { xs: '30px', md: '62px' },
//                         height: { xs: '30px', md: '52px' },
//                         borderRadius: '50%',
//                       }}
//                     />
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         flexDirection: 'column',
//                         marginLeft: isSentByCurrentUser ? 0 : '10px',
//                         marginRight: isSentByCurrentUser ? '10px' : 0,
//                         alignItems: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                       }}
//                     >
//                       <Typography
//                         sx={{
//                           fontSize: { xs: '12px', md: '13px' },
//                           fontWeight: 600,
//                           marginBottom: '4px',
//                           color: '#2563eb',
//                           textAlign: isSentByCurrentUser ? 'right' : 'left',
//                         }}
//                       >
//                         {message.sender_name}
//                       </Typography>
//                       <Box
//                         sx={{
//                           background: isSentByCurrentUser ? '#2563eb' : '#f1f5f9',
//                           color: isSentByCurrentUser ? '#fff' : '#000',
//                           borderRadius: '10px',
//                           padding: { xs: '8px 12px', md: '12px 16px' },
//                           fontSize: { xs: '12px', md: '13px' },
//                         }}
//                       >
//                         {message.message_text}
//                       </Box>
//                       <Box
//                         sx={{
//                           fontSize: { xs: '10px', md: '11px' },
//                           color: '#888',
//                           marginTop: '8px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '4px',
//                           justifyContent: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                         }}
//                       >
//                         {formatMessageTime(message.timestamp)}
//                         {/* Use our new status icon function */}
//                         {getMessageStatusIcon(message.status, isSentByCurrentUser)}
//                       </Box>
//                     </Box>
//                   </Box>
//                 );
//               })
//             ) : (
//               // If no messages, show a message indicating no messages yet
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//                 <Typography sx={{ color: '#888', fontSize: '14px' }}>
//                   No messages yet. Start the conversation!
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//           {/* Input */}
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               padding: '12px 16px',
//               borderTop: '1px solid #eee',
//               background: '#fff',
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginRight: '12px' }}>
//               {[attachIcon, photoIcon, locationIcon].map((icon, idx) => (
//                 <Box
//                   key={idx}
//                   component="img"
//                   src={icon}
//                   sx={{ width: '32px', height: '30px', cursor: 'pointer' }}
//                 />
//               ))}
//             </Box>
//             <InputBase
//               placeholder="Type your message"
//               value={inputMessage}
//               onChange={(e) => setInputMessage(e.target.value)}
//               sx={{
//                 flex: 1,
//                 padding: '10px 16px',
//                 borderRadius: '20px',
//                 border: '1px solid #ddd',
//                 background: '#f1f5f9',
//                 fontSize: '14px',
//               }}
//             />
//             <IconButton 
//               sx={{ paddingLeft: '10px' }}
//               onClick={() => {
//                 if (inputMessage.trim()) {
//                   // Call the sendMessage function with the current input message
//                   sendMessage(inputMessage);
//                 }
//               }}
//               disabled={sendingMessage}
//             >
//               <Box component="img" src={sendIcon} sx={{ width: '26px', height: '26px' }} />
//             </IconButton>
//           </Box>
//         </>
//       ) : (
//         // Show "Select a conversation" message when no conversation is selected
//         <Box 
//           sx={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             height: '100%',
//             flexDirection: 'column',
//             padding: '20px'
//           }}
//         >
//           <Typography variant="h6" sx={{ color: '#555', marginBottom: '10px' }}>
//             Select a conversation
//           </Typography>
//           <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
//             Choose a conversation from the list to start chatting
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   </Box>
// );
// };

// export default ProfileInbox;


import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, InputBase, IconButton, CircularProgress, Avatar } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { AccountCircle } from '@mui/icons-material';
import propertyImage from '../assets/inmenu.png';
import userAvatar from '../assets/inboxuser.png';
import agentAvatar from '../assets/inboxavatar.png';
import attachIcon from '../assets/clipprof.png';
import photoIcon from '../assets/clippho.png';
import locationIcon from '../assets/cliploc.png';
import sendIcon from '../assets/rocket.png';
import tickIcon from '../assets/doubletick.png';
import inboxheader from '../assets/inhead.png';
import { setCurrentConversationId, setSenderId, setReceiverId, setConversations } from '../Commonlibs/userSlice';
import Loader from '../Loader/Loader';

// SVG icons for different message statuses
const singleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const doubleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.5 8L4.5 12L11.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const doubleTickBlueSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M2.5 8L6.5 12L13.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.5 8L4.5 12L11.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const ProfileInbox = () => {
  const [conversations, setLocalConversations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [messageError, setMessageError] = useState(null);
  const [inputMessage, setInputMessage] = useState('');
  const [currentConversationId, setLocalCurrentConversationId] = useState(null);
  const [receiverId, setLocalReceiverId] = useState(null);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [otherUserOnlineStatus, setOtherUserOnlineStatus] = useState(false);
  const [otherUserLoggedInStatus, setOtherUserLoggedInStatus] = useState(false);

  const onlineStatusIntervalRef = useRef(null);

  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();

  const userId = user?.id;

  // Function to convert base64 to image URL
  const convertBase64ToImageUrl = (base64String) => {
    if (!base64String) return null;
    
    if (base64String.startsWith('data:image')) {
      return base64String;
    }
    
    if (base64String.startsWith('/9j/') || base64String.startsWith('iVBOR')) {
      return `data:image/jpeg;base64,${base64String}`;
    }
    
    return null;
  };

  const checkOtherUserOnlineStatus = async (otherUserId) => {
    if (!otherUserId) {
      console.log('No other user ID available, skipping online status check');
      return;
    }

    try {
      console.log(`Checking online status for other user ID: ${otherUserId}`);
      const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
      console.log('Other User Online Status API URL:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: otherUserId,
          is_online: true
        })
      });

      if (!response.ok) {
        console.error('Other user online status API response not OK:', response.status, response.statusText);
        throw new Error(`Other user online status API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log('Other user online status API response:', data);

      if (data.statusCode === 200) {
        const isOnline = data.result?.is_online || false;
        const isLoggedIn = data.result?.is_logged_in || false;
        console.log(`Other user (${otherUserId}) online status:`, isOnline);
        console.log(`Other user (${otherUserId}) logged in status:`, isLoggedIn);

        const prevOnlineStatus = otherUserOnlineStatus;
        const prevLoggedInStatus = otherUserLoggedInStatus;
        setOtherUserOnlineStatus(isOnline);
        setOtherUserLoggedInStatus(isLoggedIn);

        setSelectedConversation(prevConversation => {
          if (!prevConversation) return prevConversation;
          return {
            ...prevConversation,
            is_other_user_online: isOnline,
            is_other_user_logged_in: isLoggedIn
          };
        });

        setMessages(prevMessages =>
          prevMessages.map(msg => {
            if (msg.sender_id === userId) {
              if (!prevLoggedInStatus && isLoggedIn && msg.status === 'sent') {
                return { ...msg, status: 'delivered' };
              }
              else if (msg.status === 'read') {
                return msg;
              }
              else if (isOnline && msg.status === 'delivered') {
                return { ...msg, status: 'read' };
              }
              else if (prevLoggedInStatus && !isLoggedIn) {
                return { ...msg, status: 'sent' };
              }
            }
            return msg;
          })
        );
      } else {
        console.error('Other user online status API returned non-200 status code:', data.statusCode);
      }
    } catch (err) {
      console.error('Error checking other user online status:', err);
    }
  };

  useEffect(() => {
    if (!userId) {
      console.log('No user ID available, skipping online status update');
      return;
    }

    const updateOnlineStatus = async () => {
      try {
        console.log(`Updating online status for user ID: ${userId}`);
        const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
        console.log('Online Status API URL:', apiUrl);

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: userId,
            is_online: true
          })
        });

        if (!response.ok) {
          console.error('Online status update API response not OK:', response.status, response.statusText);
          throw new Error(`Online status update API request failed with status ${response.status}`);
        }

        const data = await response.json();
        console.log('Online status update API response:', data);

        if (data.statusCode !== 200) {
          console.error('Online status update API returned non-200 status code:', data.statusCode);
          throw new Error(data.message || 'Failed to update online status');
        }
      } catch (err) {
        console.error('Error updating online status:', err);
      }
    };

    updateOnlineStatus();
    const intervalId = setInterval(updateOnlineStatus, 1 * 60 * 1000);

    const handleBeforeUnload = () => {
      fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          is_online: false
        }),
        keepalive: true
      }).catch(err => console.error('Error updating offline status:', err));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          is_online: false
        }),
        keepalive: true
      }).catch(err => console.error('Error updating offline status on unmount:', err));
    };
  }, [userId]);

  useEffect(() => {
    if (onlineStatusIntervalRef.current) {
      clearInterval(onlineStatusIntervalRef.current);
      onlineStatusIntervalRef.current = null;
    }

    if (!receiverId) {
      return;
    }

    checkOtherUserOnlineStatus(receiverId);

    onlineStatusIntervalRef.current = setInterval(() => {
      checkOtherUserOnlineStatus(receiverId);
    }, 5 * 1000);

    return () => {
      if (onlineStatusIntervalRef.current) {
        clearInterval(onlineStatusIntervalRef.current);
        onlineStatusIntervalRef.current = null;
      }
    };
  }, [receiverId]);

  const markMessagesAsRead = async (conversationId) => {
    if (!userId || !conversationId) {
      console.log('Missing user ID or conversation ID, skipping mark as read');
      return;
    }

    try {
      console.log(`Marking messages as read for conversation ID: ${conversationId}, user ID: ${userId}`);
      const apiUrl = `https://propertydealstalk.com/api/messaging/markMessagesAsRead`;
      console.log('Mark as Read API URL:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          conversation_id: conversationId,
          user_id: userId
        })
      });

      if (!response.ok) {
        console.error('Mark as read API response not OK:', response.status, response.statusText);
        throw new Error(`Mark as read API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log('Mark as read API response:', data);

      if (data.statusCode !== 200) {
        console.error('Mark as read API returned non-200 status code:', data.statusCode);
        throw new Error(data.message || 'Failed to mark messages as read');
      }

      console.log(`Successfully marked ${data.result.messages_updated} messages as read`);

      setLocalConversations(prevConversations =>
        prevConversations.map(conv =>
          conv.conversation_id === conversationId
            ? {
                ...conv,
                last_message: {
                  ...conv.last_message,
                  status: 'read'
                }
              }
            : conv
        )
      );

      setMessages(prevMessages =>
        prevMessages.map(msg =>
          msg.sender_id !== userId && msg.status !== 'read'
            ? { ...msg, status: 'read' }
            : msg
        )
      );
    } catch (err) {
      console.error('Error marking messages as read:', err);
    }
  };

  useEffect(() => {
    if (!userId) {
      console.log('No user ID available, skipping API call');
      return;
    }

    const fetchConversations = async () => {
      setLoading(true);
      try {
        console.log(`Fetching conversations for user ID: ${userId}`);
        const apiUrl = `https://propertydealstalk.com/api/messaging/conversations?user_id=${userId}`;
        console.log('API URL:', apiUrl);

        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store'
          }
        });

        if (!response.ok) {
          console.error('API response not OK:', response.status, response.statusText);
          throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();
        console.log('API response:', data);

        if (data.statusCode === 200) {
          console.log('Conversations data:', data.result);

          const processedConversations = data.result.map(conversation => {
            const imageUrl = convertBase64ToImageUrl(conversation.property?.image);
            
            return {
              ...conversation,
              property: {
                ...conversation.property,
                image: imageUrl || propertyImage
              }
            };
          });

          setLocalConversations(processedConversations);

          if (processedConversations && processedConversations.length > 0) {
            try {
              dispatch(setConversations(processedConversations));
            } catch (err) {
              console.error('Error updating Redux state:', err);
            }
          }

          if (processedConversations.length > 0 && !currentConversationId) {
            const firstConversation = processedConversations[0];
            setSelectedConversation(firstConversation);
            setLocalCurrentConversationId(firstConversation.conversation_id);

            if (firstConversation.other_user && firstConversation.other_user.id) {
              const otherUserId = firstConversation.other_user.id;
              setLocalReceiverId(otherUserId);
              checkOtherUserOnlineStatus(otherUserId);
              try {
                dispatch(setReceiverId(otherUserId));
              } catch (err) {
                console.error('Error updating Redux receiver ID:', err);
              }
            }

            try {
              dispatch(setCurrentConversationId(firstConversation.conversation_id));
              if (firstConversation.other_user && firstConversation.other_user.id) {
                dispatch(setSenderId(firstConversation.other_user.id));
              }
            } catch (err) {
              console.error('Error updating Redux state:', err);
            }

            fetchMessages(firstConversation.conversation_id);
            markMessagesAsRead(firstConversation.conversation_id);
          } else if (currentConversationId) {
            const existingConversation = processedConversations.find(
              conv => conv.conversation_id === currentConversationId
            );
            if (existingConversation) {
              setSelectedConversation(existingConversation);
              if (existingConversation.other_user && existingConversation.other_user.id) {
                const otherUserId = existingConversation.other_user.id;
                setLocalReceiverId(otherUserId);
                checkOtherUserOnlineStatus(otherUserId);
                try {
                  dispatch(setReceiverId(otherUserId));
                } catch (err) {
                  console.error('Error updating Redux receiver ID:', err);
                }
              }
              fetchMessages(currentConversationId);
              markMessagesAsRead(currentConversationId);
            }
          }
        } else {
          console.error('API returned non-200 status code:', data.statusCode);
          throw new Error(data.message || 'Failed to fetch conversations');
        }
      } catch (err) {
        console.error('Error fetching conversations:', err);
        console.error('Error details:', err.message);
        console.error('Error stack:', err.stack);
        setError(`Error: Failed to fetch. Please try again later.`);
        setLocalConversations([]);
      } finally {
        setLoading(false);
      }
    };

    fetchConversations();
  }, [userId, dispatch]);

  const fetchMessages = async (conversationId) => {
    if (!userId || !conversationId) {
      console.log('Missing user ID or conversation ID, skipping message fetch');
      return;
    }

    setLoadingMessages(true);
    setMessageError(null);

    try {
      console.log(`Fetching messages for conversation ID: ${conversationId}, user ID: ${userId}`);
      const apiUrl = `https://propertydealstalk.com/api/messaging/getMessages?conversation_id=${conversationId}&user_id=${userId}`;
      console.log('Messages API URL:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store'
        }
      });

      if (!response.ok) {
        console.error('Messages API response not OK:', response.status, response.statusText);
        throw new Error(`Messages API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log('Messages API response:', data);

      if (data.statusCode === 200) {
        console.log('Messages data:', data.result.messages);
        const messagesArray = Array.isArray(data.result.messages) ? data.result.messages : [];

        const processedMessages = messagesArray.map(msg => {
          if (msg.sender_id === userId) {
            if (!msg.status) {
              if (otherUserOnlineStatus) {
                return { ...msg, status: 'read' };
              } else if (otherUserLoggedInStatus) {
                return { ...msg, status: 'delivered' };
              } else {
                return { ...msg, status: 'sent' };
              }
            }
          } else {
            return { ...msg, status: 'read' };
          }
          return msg;
        });

        setMessages(processedMessages);

        if (!receiverId && selectedConversation?.other_user?.id) {
          const otherUserId = selectedConversation.other_user.id;
          setLocalReceiverId(otherUserId);
          checkOtherUserOnlineStatus(otherUserId);
          try {
            dispatch(setReceiverId(otherUserId));
          } catch (err) {
            console.error('Error updating Redux receiver ID:', err);
          }
        }

        markMessagesAsRead(conversationId);
      } else {
        console.error('Messages API returned non-200 status code:', data.statusCode);
        throw new Error(data.message || 'Failed to fetch messages');
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
      console.error('Error details:', err.message);
      setMessageError('Failed to load messages. Please try again later.');
      setMessages([]);
    } finally {
      setLoadingMessages(false);
    }
  };

  const sendMessage = async (messageText) => {
    if (!messageText.trim()) {
      console.log('Message text is empty');
      return;
    }

    if (!currentConversationId) {
      console.log('Missing conversation ID');
      return;
    }

    if (!userId) {
      console.log('Missing user ID');
      return;
    }

    let actualReceiverId = receiverId;
    if (!actualReceiverId && selectedConversation?.other_user?.id) {
      actualReceiverId = selectedConversation.other_user.id;
      setLocalReceiverId(actualReceiverId);
      checkOtherUserOnlineStatus(actualReceiverId);
      try {
        dispatch(setReceiverId(actualReceiverId));
      } catch (err) {
        console.error('Error updating Redux receiver ID:', err);
      }
    }

    if (!actualReceiverId) {
      console.log('Missing receiver ID and cannot determine from conversation');
      return;
    }

    setSendingMessage(true);

    try {
      let initialStatus = 'sent';
      if (otherUserOnlineStatus) {
        initialStatus = 'read';
      } else if (otherUserLoggedInStatus) {
        initialStatus = 'delivered';
      }

      const tempMessage = {
        message_id: `temp-${Date.now()}`,
        message_text: messageText,
        sender_id: userId,
        sender_name: user?.full_name || 'You',
        receiver_id: actualReceiverId,
        receiver_name: 'Receiver',
        timestamp: new Date().toISOString(),
        status: initialStatus
      };

      setMessages(prevMessages => [...prevMessages, tempMessage]);
      setInputMessage('');

      const apiUrl = 'https://propertydealstalk.com/api/messaging/sendMessage';
      console.log('Send Message API URL:', apiUrl);

      const requestBody = {
        conversation_id: currentConversationId,
        receiver_id: actualReceiverId,
        sender_id: userId,
        message_text: messageText
      };

      console.log('Sending message with data:', requestBody);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        console.error('Send message API response not OK:', response.status, response.statusText);
        throw new Error(`Send message API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log('Send message API response:', data);

      if (data.statusCode === 200) {
        console.log('Message sent successfully:', data.result);

        setMessages(prevMessages =>
          prevMessages.map(msg =>
            msg.message_id === tempMessage.message_id
              ? {
                  ...msg,
                  message_id: data.result.message_id,
                  timestamp: data.result.timestamp,
                  status: initialStatus
                }
              : msg
          )
        );
      } else {
        console.error('Send message API returned non-200 status code:', data.statusCode);
        throw new Error(data.message || 'Failed to send message');
      }
    } catch (err) {
      console.error('Error sending message:', err);
      console.error('Error details:', err.message);

      setMessages(prevMessages =>
        prevMessages.map(msg =>
          msg.status === 'sending'
            ? { ...msg, status: 'failed' }
            : msg
        )
      );
    } finally {
      setSendingMessage(false);
    }
  };

  const handleConversationSelect = (conversation) => {
    setSelectedConversation(conversation);
    setLocalCurrentConversationId(conversation.conversation_id);

    if (conversation.other_user && conversation.other_user.id) {
      const otherUserId = conversation.other_user.id;
      setLocalReceiverId(otherUserId);
      checkOtherUserOnlineStatus(otherUserId);
      try {
        dispatch(setReceiverId(otherUserId));
      } catch (err) {
        console.error('Error updating Redux receiver ID:', err);
      }
    }

    try {
      dispatch(setCurrentConversationId(conversation.conversation_id));
      if (conversation.other_user && conversation.other_user.id) {
        dispatch(setSenderId(conversation.other_user.id));
      }
    } catch (err) {
      console.error('Error updating Redux state:', err);
    }

    fetchMessages(conversation.conversation_id);
    markMessagesAsRead(conversation.conversation_id);
  };

  const formatRelativeTime = (timestamp) => {
    if (!timestamp) return '';

    try {
      const now = new Date();
      const messageTime = new Date(timestamp);

      if (isNaN(messageTime.getTime())) {
        console.error('Invalid date:', timestamp);
        return 'Invalid date';
      }

      const diffInMs = now - messageTime;
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

      if (diffInMinutes < 1) return 'just now';
      if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

      const diffInHours = Math.floor(diffInMinutes / 60);
      if (diffInHours < 24) return `${diffInHours}h ago`;

      const diffInDays = Math.floor(diffInHours / 24);
      if (diffInDays < 7) return `${diffInDays}d ago`;

      return messageTime.toLocaleDateString();
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Date error';
    }
  };

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';

    try {
      const date = new Date(timestamp);

      if (isNaN(date.getTime())) {
        return 'Invalid time';
      }

      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      console.error('Error formatting time:', error);
      return 'Time error';
    }
  };

  const getMessageStatusIcon = (status, isSentByCurrentUser) => {
    if (!isSentByCurrentUser) return null;

    switch (status) {
      case 'sent':
        return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
      case 'delivered':
        return <div dangerouslySetInnerHTML={{ __html: doubleTickSvg }} />;
      case 'read':
        return <div dangerouslySetInnerHTML={{ __html: doubleTickBlueSvg }} />;
      case 'failed':
        return <Typography sx={{ color: 'red', fontSize: '10px' }}>Failed</Typography>;
      default:
        return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
    }
  };

  if (!userId) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6">Please log in to view your messages</Typography>
        <Typography variant="body2" color="text.secondary">
          You need to be logged in to access your conversations
        </Typography>
      </Box>
    );
  }

  if (loading) return <Loader />;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '10px', md: '20px' },
        width: '100%',
      }}
    >
      {/* Inbox List */}
      <Box
        sx={{
          width: { xs: '100%', md: '320px' },
          background: '#fff',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          padding: { xs: '12px', md: '46px 16px 0 16px' }, // ✅ Fixed: Reduced mobile top padding from 20px to 12px
        }}
      >
        {error ? (
          <Box sx={{ padding: '20px', textAlign: 'center' }}>
            <Typography sx={{ color: 'red', marginBottom: '10px' }}>
              Error: Failed to fetch. Please try again later.
            </Typography>
          </Box>
        ) : conversations.length > 0 ? (
          conversations.map((conversation) => (
            <Box
              key={conversation.conversation_id}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                padding: '10px',
                border: '2px solid #f1f1f1',
                borderRadius: '9px',
                cursor: 'pointer',
                marginBottom: '12px', // ✅ Fixed: Reduced from 20px to 12px for better spacing
                backgroundColor: selectedConversation?.conversation_id === conversation.conversation_id ? '#f8f9fa' : 'transparent',
              }}
              onClick={() => handleConversationSelect(conversation)}
            >
              <img
                src={conversation.property.image}
                alt="Property"
                style={{
                  width: '40px',
                  height: '38px',
                  borderRadius: '8px',
                  marginRight: '12px',
                  objectFit: 'cover',
                }}
                onError={(e) => {
                  console.warn('Image failed to load, using fallback');
                  e.target.src = propertyImage;
                }}
              />
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                  }}
                >
                  <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600 }}>
                    {conversation.property.property_name}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                    }}
                  >
                    {conversation.last_message.status !== 'read' && (
                      <Box
                        sx={{
                          width: '8px',
                          height: '8px',
                          background: 'red',
                          borderRadius: '50%',
                        }}
                      />
                    )}
                    <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
                      {formatRelativeTime(conversation.last_message_time)}
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555' }}>
                  {conversation.last_message.message_text}
                </Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography sx={{ color: '#888', fontSize: '14px' }}>
              No conversations yet
            </Typography>
          </Box>
        )}
      </Box>

      {/* Chatbox */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          background: '#fff',
          borderRadius: '8px',
          maxWidth: { md: '660px', xs: '100%' },
          width: '100%',
        }}
      >
        {/* Header section */}
        {selectedConversation && selectedConversation.property ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'flex-start',
              padding: { xs: '12px', md: '25px 9px 0 9px' },
              borderBottom: '2px solid #eee',
              height: { xs: 'auto', md: '110px' },
            }}
          >
            <img
              src={selectedConversation.property.image}
              alt="Property"
              style={{
                width: '140px',
                height: '70px',
                borderRadius: '8px',
                marginRight: '22px',
                marginLeft: '20px',
                objectFit: 'cover',
              }}
              onError={(e) => {
                console.warn('Header image failed to load, using fallback');
                e.target.src = inboxheader;
              }}
            />
            <Box>
              <Typography sx={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>
                {selectedConversation.property.property_name}
              </Typography>
              <Typography
                sx={{
                  margin: '8px 0',
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#2563eb'
                }}
              >
                {selectedConversation.property.category === 'sale' 
                  ? `${selectedConversation.property.currency}${selectedConversation.property.asking_price || 'N/A'}`
                  : `${selectedConversation.property.currency}${selectedConversation.property.monthly_rent || 'N/A'}/month`
                }
              </Typography>
              <Typography sx={{ margin: 0, fontSize: '12px', color: '#444' }}>
                {selectedConversation.property.location}
              </Typography>
            </Box>
            <Typography
              sx={{
                marginLeft: 'auto',
                fontSize: '14px',
                color: selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'green' : '#888',
                alignSelf: 'flex-end',
                marginBottom: '6px',
              }}
            >
              ● {selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'Online' : 'Offline'}
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '110px',
              borderBottom: '2px solid #eee',
            }}
          >
            <Typography sx={{ color: '#888', fontSize: '14px' }}>
              Select a conversation
            </Typography>
          </Box>
        )}

        {/* Messages */}
        {selectedConversation ? (
          <>
            <Box
              sx={{
                flex: 1,
                padding: { xs: '16px', md: '24px' }, // ✅ Fixed: Reduced mobile padding from 24px to 16px
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '16px', md: '28px' }, // ✅ Fixed: Reduced mobile gap from 28px to 16px
                overflowY: 'auto',
              }}
            >
              {loadingMessages ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                  <CircularProgress size={24} />
                </Box>
              ) : messageError ? (
                <Box sx={{ padding: '20px', textAlign: 'center' }}>
                  <Typography sx={{ color: 'red', marginBottom: '10px' }}>
                    {messageError}
                  </Typography>
                </Box>
              ) : messages.length > 0 ? (
                messages.map((message) => {
                  const isSentByCurrentUser = message.sender_id === userId;
                  return (
                    <Box
                      key={message.message_id}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        maxWidth: '100%',
                        flexDirection: isSentByCurrentUser ? 'row-reverse' : 'row',
                        alignSelf: isSentByCurrentUser ? 'flex-end' : 'flex-start',
                      }}
                    >
                      <Avatar
                        sx={{
                          width: { xs: 30, md: 52 },
                          height: { xs: 30, md: 52 },
                          bgcolor: isSentByCurrentUser ? '#2563eb' : '#9ca3af',
                        }}
                      >
                        <AccountCircle sx={{ width: '100%', height: '100%' }} />
                      </Avatar>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginLeft: isSentByCurrentUser ? 0 : '10px',
                          marginRight: isSentByCurrentUser ? '10px' : 0,
                          alignItems: isSentByCurrentUser ? 'flex-end' : 'flex-start',
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: '12px', md: '13px' },
                            fontWeight: 600,
                            marginBottom: '4px',
                            color: '#2563eb',
                            textAlign: isSentByCurrentUser ? 'right' : 'left',
                          }}
                        >
                          {message.sender_name}
                        </Typography>
                        <Box
                          sx={{
                            background: isSentByCurrentUser ? '#2563eb' : '#f1f5f9',
                            color: isSentByCurrentUser ? '#fff' : '#000',
                            borderRadius: '10px',
                            padding: { xs: '8px 12px', md: '12px 16px' },
                            fontSize: { xs: '12px', md: '13px' },
                          }}
                        >
                          {message.message_text}
                        </Box>
                        <Box
                          sx={{
                            fontSize: { xs: '10px', md: '11px' },
                            color: '#888',
                            marginTop: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            justifyContent: isSentByCurrentUser ? 'flex-end' : 'flex-start',
                          }}
                        >
                          {formatMessageTime(message.timestamp)}
                          {getMessageStatusIcon(message.status, isSentByCurrentUser)}
                        </Box>
                      </Box>
                    </Box>
                  );
                })
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography sx={{ color: '#888', fontSize: '14px' }}>
                    No messages yet. Start the conversation!
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Input */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 16px',
                borderTop: '1px solid #eee',
                background: '#fff',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginRight: '12px' }}>
                {[attachIcon, photoIcon, locationIcon].map((icon, idx) => (
                  <Box
                    key={idx}
                    component="img"
                    src={icon}
                    sx={{ width: '32px', height: '30px', cursor: 'pointer' }}
                  />
                ))}
              </Box>
              <InputBase
                placeholder="Type your message"
                value={inputMessage}
                onChange={(e) => setInputMessage(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    if (inputMessage.trim()) {
                      sendMessage(inputMessage);
                    }
                  }
                }}
                sx={{
                  flex: 1,
                  padding: '10px 16px',
                  borderRadius: '20px',
                  border: '1px solid #ddd',
                  background: '#f1f5f9',
                  fontSize: '14px',
                }}
              />
              <IconButton
                sx={{ paddingLeft: '10px' }}
                onClick={() => {
                  if (inputMessage.trim()) {
                    sendMessage(inputMessage);
                  }
                }}
                disabled={sendingMessage}
              >
                <Box component="img" src={sendIcon} sx={{ width: '26px', height: '26px' }} />
              </IconButton>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              flexDirection: 'column',
              padding: '20px'
            }}
          >
            <Typography variant="h6" sx={{ color: '#555', marginBottom: '10px' }}>
              Select a conversation
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
              Choose a conversation from the list to start chatting
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProfileInbox;